import { UserCoreModel } from '../users-core/users-core.model'
import { IUserPublicInterface } from './users-public.interface'
import TimeLib from '../../lib/Time'

// We need user public model because this model doesn't have private keys like userStripeId e.t.c.
export class UserPublicModel extends UserCoreModel {
  public modified: IUserPublicInterface['modified']
  public created: IUserPublicInterface['created']

  constructor(obj?: IUserPublicInterface) {
    super(obj)
    this.modified = obj?.modified ?? TimeLib.utcTimestamp()
    this.created = obj?.created ?? TimeLib.utcTimestamp()
  }
  static fromFirestoreDoc(doc: any) {
    return new UserCoreModel({
      id: doc.id,
      ...doc.data(),
    })
  }
}
